<template>
  <div>
    <b-row>
        <b-col>
            <h5 class="page-title">
              <span class="t-link" @click="$router.push('clients')">{{$t("Clients")}}</span> / {{$t("Equipments")}}
            </h5>
        </b-col>
    </b-row>
    <br>
    <b-row>
        <b-col>
            <b-card class="bg-t-dark order-filters">  
              <b-row>
                <b-col md="8">
                  <h5>
                    Hospital geral de cuidados
                  </h5>
                  <span>
                    Brazil
                  </span>
                </b-col>
                <b-col class="text-right text-end" align="end">
                  <h5>
                    53 {{$t("Equipments")}}
                  </h5>
                </b-col>
              </b-row>
            </b-card>
            <br>
            <b-card class="bg-t-dark order-filters">
              <b-row>
                <b-col>
                  {{$t("Filters")}}:
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-row>
                    <b-col>
                      <small>{{$t("Search")}}</small>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-input placeholder="By modules or serial number"></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="3">
                  <b-row>
                    <b-col>
                      <small>{{$t("Software version")}}</small>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-select class="form-control form-select" placeholder="Selecione">
                        <b-form-select-option :value="null">Please select an option</b-form-select-option>
                        <b-form-select-option value="a">Option A</b-form-select-option>
                        <b-form-select-option value="b" disabled>Option B (disabled)</b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="3">
                  <b-row>
                    <b-col>
                      <small>{{$t("Equipment model")}}</small>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-select class="form-control form-select" placeholder="Selecione">
                        <b-form-select-option :value="null">Please select an option</b-form-select-option>
                        <b-form-select-option value="a">Option A</b-form-select-option>
                        <b-form-select-option value="b" disabled>Option B (disabled)</b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="2">
                  <b-row>
                    <b-col>
                      &nbsp;
                    </b-col>
                  </b-row>
                  <b-row align="end" align-h="end">
                    <b-col align-h="end">
                      <b-btn variant="outline-t-blue">
                        {{$t("Clear")}}
                      </b-btn>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
        </b-col>
    </b-row>
    
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
            <EquipmentCard/>
        </b-col>
    </b-row>
    <div class="mt-3">
      <b-pagination v-model="currentPage" :total-rows="rows" align="right"></b-pagination>
    </div>
  </div>
</template>

<script>
  import EquipmentCard from "./components/EquipmentCard.vue"

  export default {
    components:{
      EquipmentCard
    },
    methods:{
        dateParse(date_iso){
          let date = new Date(date_iso)
          let day_month = date.toLocaleDateString().substr(0,6)
          let year = date.getFullYear().toString().substr(-2)
          return `${day_month}${year}`
        }
    },
    data() {
      return {
        rows: 100,
        currentPage: 3,
        items: [
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
          {
            date: this.dateParse(new Date().toISOString()),
            client: "Lorem ipsum",
            model: "13",
            amount: "13",
            mode: "Lorem ipsum"
          },
        ],
        fields:[
            {
              key: 'date',
              label: 'Data'
            },
            {
              key: 'client',
              label: 'Cliente'
            },
            {
              key: 'model',
              label: 'Modelo'
            },
            {
              key: 'amount',
              label: 'Qtd'
            },
            {
              key: 'mode',
              label: 'Modo'
            },
        ]
      }
    }
  }
</script>

<style lang="scss">
  .order-filters{
    .form-control{
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-control:focus {
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-select{
      background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
    }
    ::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  }
</style>